import { useRef } from 'react';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';

const AWARDS = [
  {
    img: 'https://brainardsgreenscapes.com/assets/images/award1.jpg',
    label: 'Best of Las Cruces 2019',
  },
  {
    img: 'https://brainardsgreenscapes.com/assets/images/award2.jpg',
    label: 'Best of Las Cruces 2022',
  },
  {
    img: 'https://brainardsgreenscapes.com/assets/images/award3.jpg',
    label: 'Best of Las Cruces 2023',
  },
];

export default function AwardsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const visible = useIntersectionObserver(ref, { threshold: 0.2 });

  return (
    <section className="bg-white border-y border-stone-100 py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div
          ref={ref}
          className={`flex flex-col items-center transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
        >
          <p className="font-sans text-forest-500 text-xs tracking-[0.25em] uppercase mb-3">Recognition</p>
          <h2 className="font-serif text-charcoal-900 text-2xl font-semibold mb-10">Awards &amp; Recognition</h2>

          <div className="flex items-center justify-center gap-16">
            {AWARDS.map((award, i) => (
              <div
                key={award.label}
                className={`flex flex-col items-center gap-4 transition-all duration-700 ${visible ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}
                style={{ transitionDelay: `${i * 120}ms` }}
              >
                <div className="w-36 h-36 rounded-full overflow-hidden border-4 border-stone-100 bg-stone-50 flex items-center justify-center">
                  <img
                    src={award.img}
                    alt={award.label}
                    className="w-full h-full object-cover object-center"
                  />
                </div>
                <span className="font-sans text-charcoal-700 text-sm font-medium text-center">{award.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
